import { Button, CircularProgress, Container, Grid, Typography, Box, TextField, InputAdornment } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import GoogleSwiper from "../Swiper";
import { PlanModal } from "../v2/enrollment/PlanModal";
import { ErrorModal } from "../v2/enrollment/ErrorModal";
import {
  PROMO_CODE,
  PROVIDER_ID,
  PROVIDER_NAME,
  REPs,
  Tier,
} from "../../config";
import {
  ACPlans,
  ACRows,
  AddressProps,
  ChartDataTypes,
  PlanProps,
  UtilityTypes,
} from "../../types";
import useIpZipCode from "../../hooks/useIpZipCode";
import {
  CNP_CODES,
  DM_CODES,
  LPL_CODES,
  ONCOR_CODES,
  KH_CODES,
  KH_CODES_MAP,
  getBestRate,
  getBestValue,
} from "../data";
import {
  fetchConstellationPlans,
  fetchFliterMonth,
  fetchPlan,
  fetchThreeHeightsPlan,
  fetchUtility,
} from "../../fetch/fetch";
import {
  ChoiceSection,
  EvaluateSection,
  HomeIntroContentSection,
  HomeIntroSection,
  IntroContentSection,
  IntroSection,
  SectionWrapper,
  TickGrid,
  TickSection,
} from "../styles/saving-section.styled";
import { EntrySection } from "../styles/common.styled";
import { ChartSection } from "../styles/v2/saving-section.styled";
import { withSnackbar } from "../SnackbarHOC";
import { ACGridContainer } from "../styles/compare.styled";
import { RollingNumber } from "../RollingNumber";
import CompareGrid from "./CompareGrid";
import { CompareGridContext } from "../../context-manager";

const AcPage = ({
  snackbarShowMessage,
}: {
  snackbarShowMessage?: Function;
}) => {
  const location = useLocation();
  const [zipcode, setZipcode] = useState("");
  const [selectedTerm, setSelectedTerm] = useState("12");
  const [utilities, setUtilities] = useState<UtilityTypes[]>([]);
  const [selectedUtility, setSelectedUtility] = useState("");
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<ChartDataTypes[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [oneRepPlanList, setOneRepPlanList] = useState<PlanProps[]>([]);
  const [plans, setPlans] = useState<
    { [key: string]: PlanProps[] } | undefined
  >(undefined);
  const [products, setProducts] = useState<PlanProps[]>([]);
  const mainRef = useRef<null | HTMLDivElement>(null);
  const [threeHeightPlans, setThreeHeightPlans] = useState<
    { [key: string]: PlanProps[] } | undefined
  >();
  const [isThreePlan, setIsThreePlan] = useState(false);
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  const [acPlans, setACPlans] = useState<ACPlans[]>([]);
  const [acRow, setACRows] = useState<ACRows[]>([]);
  const [promoCode, setPromoCode] = useState<string>();
  // To persist the tier 1 data for chart in three heights plan
  const [energySavings, setEnergySavings] = useState(0);
  const [errorModalContent, setErrorModalContent] = useState<any>(undefined);
  const mediaQuery = useMediaQuery("(max-width:430px)");
  const isComparePage = location.pathname === "/";

  const { ipZipCode, isFetching } = useIpZipCode();
  useEffect(() => {
    // For AC Protection Plan Grid No Zipcode Input
    const promocode = location.pathname.substring(1);

    let _zipcode = "";
    if (KH_CODES_MAP[promocode]) {
      _zipcode = KH_CODES_MAP[promocode].zipcode;
      setZipcode(_zipcode);
      return;
    } 

    if (CNP_CODES.includes(promocode)) {
      setZipcode("77020");
    } else if (ONCOR_CODES.includes(promocode)) {
      setZipcode("75201");
    } else if (LPL_CODES.includes(promocode)) {
      setZipcode("79416");
    } else {
      if (ipZipCode) {
        setZipcode(ipZipCode);
      }
    }
  }, [ipZipCode]);

  // Set the promocode from the url params
  useEffect(() => {
    setPromoCode((location.pathname.substring(1) as string) || PROMO_CODE);
    // Storing Promocode for retreving in Enrollment Funnel
    localStorage.setItem(
      "promoCode",
      (location.pathname.substring(1) as string) || PROMO_CODE
    );
  }, [location]);
  const isLplPage = useMemo(() => {
    if (LPL_CODES.includes(promoCode || "")) {
      return true;
    }
    return false;
  }, [promoCode]);

  const isDmPage = useMemo(()=>{
    if (DM_CODES.includes(promoCode || "")) {
      return true
    }
    return false;
  }, [promoCode])
// KH Page Banti
  const isKhPage = useMemo(() => {
    if (KH_CODES.includes(promoCode || "")) {
      return true;
    }
    return false;
  }, [promoCode]);

  useEffect(() => {
    if (zipcode.length === 5 && !loading) {
      setProducts([]);
      setLoading(true);
      setIsThreePlan(false);
      setSelectedUtility("");
      setUtilities([]);
      setSelectedTerm("");
      setChartData([]);
      getUtility();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode]);

  // Fn to fetch the utilities
  const getUtility = () => {
    fetchUtility(zipcode).then((res) => {
      if (res && res[0] && res[0].utility_code) {
        setUtilities(res);
        setSelectedUtility(res[0].utility_name);
        setSelectedTerm("12");
        setLoading(false);
      }
    });
  };
  // Once user selects the utility fetch the terms[12,24,36] for usage
  useEffect(() => {
    if (!selectedUtility) return;
    const utilityCode = findUtilityCode();
    if (utilityCode) {
      setSelectedTerm("12");
      setLoading(true);
      fetchFliterMonth(zipcode, utilityCode, promoCode).then((res) => {
        if (res && Number(res.status) === 1) {
          let terms = res.response.terms;
          terms.sort((a: string, b: string) => {
            if (parseInt(a) < parseInt(b)) return -1;
            if (parseInt(a) > parseInt(b)) return 1;
            return 0;
          });
          // Adding 36 month plan
          // terms.push("36")
          if (terms.length > 0) {
            if (terms.indexOf("12") >= 0) {
              setSelectedTerm("12");
            } else {
              setSelectedTerm(terms[0]);
            }
          }
        } else {
          // For KH routes, default to 12 months if terms API fails
          if (KH_CODES.includes(promoCode || "")) {
            setSelectedTerm("12");
          } else {
            snackbarShowMessage?.(res.msg, "error");
          }
          setLoading(false);
        }
        setLoading(false);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUtility]);

  // If user selects term and usage then fetch the plans and products
  useEffect(() => {
    if (selectedTerm && selectedUtility) {
      setChartData([]);
      setIsThreePlan(false);
      setPlans(undefined);
      setProducts([]);
      getProducts();
      getPlan();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTerm]);
  // Remove any existing addresses,plans in the local storage
  useEffect(() => {
    localStorage.removeItem("selectedAddress");
    localStorage.removeItem("ts_plan");
  }, []);

  // Handle scroll when user clicks on view plans
  const handleScroll = () => {
    if (mainRef && mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };
  // Util fn to get the utility code for util name
  const findUtilityCode = () => {
    if (!selectedUtility) return "";
    return utilities.filter((val) => val.utility_name === selectedUtility)[0]
      .utility_code;
  };

  // Fetching constellation Plans
  const getProducts = (myUsage?: Number[]) => {
    setLoading(true);
    const utilityCode = findUtilityCode();
    const term = selectedTerm ? selectedTerm : "12";
    const provider_id = PROVIDER_ID;
    const usages = myUsage ? myUsage : new Array(12).fill(parseInt("1000"));

    fetchConstellationPlans(
      zipcode,
      utilityCode,
      term,
      provider_id,
      usages,
      promoCode
    ).then((res: any) => {
      setLoading(false);
      if (res && Number(res.status) === 1) {
        const { plans } = res.response;
        if (plans) {
          var _plans = plans.filter(
            (item: any) => item.plan_name.indexOf("Flat Tier Product") === -1
          );
          setProducts(_plans);
        }
        if (res.response.utility) {
          localStorage.setItem("utility", JSON.stringify(res.response.utility));
        }
      } else {
        // Retry without promo code for KH routes if no products returned
        if (KH_CODES.includes(promoCode || "")) {
          fetchConstellationPlans(
            zipcode,
            utilityCode,
            term,
            provider_id,
            usages,
            promoCode,
          ).then((retryRes: any) => {
            if (retryRes && Number(retryRes.status) === 1) {
              const { plans } = retryRes.response;
              if (plans) {
                var _plans = plans.filter(
                  (item: any) => item.plan_name.indexOf("Flat Tier Product") === -1
                );
                setProducts(_plans);
              }
              if (retryRes.response.utility) {
                localStorage.setItem("utility", JSON.stringify(retryRes.response.utility));
              }
            } else {
              setProducts([]);
            }
          });
        } else {
          setProducts([]);
        }
      }
    });
  };
  // Fetch the competitor prices
  const getPlan = (myUsage?: Number[]) => {
    const usages = myUsage
      ? myUsage
      : new Array(Number(selectedTerm ? selectedTerm : "12")).fill(
          parseInt("1000")
        );

    const utilityCode = findUtilityCode();

    setLoading(true);
    setChartLoading(true);
    let tempSelectedTerm;
    if (isLplPage) {
      tempSelectedTerm = "";
    }
    fetchPlan(
      isLplPage || isKhPage ? 0 : parseInt(tempSelectedTerm || selectedTerm),
      utilityCode,
      usages
    ).then((res) => {
      setLoading(false);
      if (res && res.code === 1) {
        const allPlans = res.response;
        setPlans(allPlans);
        // setTimeout(() => {
        //     handleScroll();
        // }, 200);
      }
      if (res && res.code === 0) {
        getThreeHeightsPlan();
      }
    });
  };
  // Fetch the three heights plans
  const getThreeHeightsPlan = () => {
    const usages = new Array(Number(selectedTerm ? selectedTerm : "12")).fill(
      parseInt("1000")
    );
    const utilityCode = findUtilityCode();
    setIsThreePlan(true);
    fetchThreeHeightsPlan(
      parseInt(selectedTerm ? selectedTerm : "12"),
      utilityCode,
      usages
    ).then((res) => {
      if (res && res.code === 1) {
        const allPlans = res.response;
        setThreeHeightPlans(allPlans);
      } else {
        snackbarShowMessage?.(res.msg, "error");
      }
    });
  };

  // If any of products or plans change recalculate the average rate
  useEffect(() => {
    getAverageRate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, plans]);

  useEffect(()=>{
    if (chartData && chartData.length > 0) {
      const rateDiff = chartData[chartData.length - 1]
        ? chartData[chartData.length - 1].value - chartData[0].value
        : 0;
      setEnergySavings((rateDiff * parseFloat('1000') * parseInt(selectedTerm)) / 100)
    }
  },[chartData])

  // Fn to calculate the average rate
  const getAverageRate = () => {
    if (!plans) {
      return;
    }
    if (products.length !== 0 && plans) {
      let allPlans: any = plans;
      const BestRate = getBestRate(promoCode);
      const BestValue = getBestValue(promoCode);
      let _products: PlanProps[] = [];
      if (promoCode === PROMO_CODE) {
        _products = products.filter(
          (item) =>
            BestRate.indexOf(Number(item.plan_id)) ||
            BestValue.indexOf(Number(item.plan_id))
        );
      } else {
        if (isLplPage || isKhPage) {
          _products = products.filter(
            (item: PlanProps) =>
              BestRate.indexOf(Number(item.plan_id)) ||
              BestValue.indexOf(Number(item.plan_id))
          );
        }                     
        else {
          _products = products.filter(
            (item: PlanProps) =>
              (BestRate.indexOf(Number(item.plan_id)) ||
                BestValue.indexOf(Number(item.plan_id))) &&
              Number(item.contract_term) === 12
          );
        }
      }
      // Price Type is value to be used based on monthly usage like price500,price1000
      const priceType = "price" + "1000";
      // This is constellations cheapest plan rate
      let total_price: number;
      let ac_total_price: number;
      if (isLplPage) {
        total_price = Number(
          _products[
            _products.findIndex((item: any) =>
              item.plan_name.includes("Usage Bill Credit")
            )
          ]["price1000"]
        );
      } else {
        total_price = Number(
          _products[
            _products.findIndex((item: any) =>
              item.plan_name.includes("12 Month Usage")
            )
          ]["price1000"]
        );
      }

      ac_total_price = Number(
        _products[
          _products.findIndex((item: any) =>
            item.plan_name.includes("A/C Protect Plus")
          )
        ]?.["price1000"] || 0
      );
      let data: any = [];
      // This is for AC Grid in Home Page
      let ac_data: any = [];
      for (let i in allPlans) {
        const _plans = allPlans[i];
        // Sort the plans for each rep in descending order
        _plans.sort((a: any, b: any) => {
          if (a.total_rate < b.total_rate) return -1;
          if (a.value > b.value) return 1;
          return 0;
        });
        if (i !== PROVIDER_ID) {
          let ind = 0;
          let ac_ind = 0;
          if (!isLplPage) {
            if (i === REPs[1].providerId) {
              ind = _plans.findIndex((item: any) =>
                item.plan_name.includes("Live Brighter")
              );
            } else if (i === REPs[2].providerId) {
              ind = _plans.findIndex((item: any) =>
                item.plan_name.includes("Saver's Choice 12")
              );
            } else if (i === REPs[3].providerId) {
              ind = _plans.findIndex((item: any) =>
                item.plan_name.includes("Reliant Secure Advantage® 12 plan")
              );
            }
          } else {
            if (i === REPs[1].providerId) continue;
            if (i === REPs[2].providerId) {
              ind = _plans.findIndex((item: any) =>
                item.plan_name.includes("On Your Terms")
              );
            } else if (i === REPs[3].providerId) {
              ind = _plans.findIndex((item: any) =>
                item.plan_name.includes("Clear Flex plan")
              );
            }
          }

          if (_plans[ind]?.total_rate) {
            data.push({
              id: i,
              value: Number(_plans[ind][priceType]),
              label:
                _plans[ind].provider_name ||
                REPs.filter((item) => item.providerId === i)[0].providerName,
            });
          }
          if (_plans[ac_ind]?.total_rate) {
            ac_data.push({
              id: i,
              value: Number(_plans[ac_ind][priceType]),
              label:
                _plans[ac_ind].provider_name ||
                REPs.filter((item) => item.providerId === i)[0].providerName,
            });
          }
        }
      }

      // If number of  tier 1 competitors to show is less than 3 fetch tier 2

      // Sort data in descending order by value
      data.sort((a: any, b: any) => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      });
      let _chartData: any = [];
      let _acChartData: any = [];
      _chartData.push({
        id: PROVIDER_ID,
        // value: Math.ceil(total_price / products.length * 100) / 100,
        value: total_price,
        label: PROVIDER_NAME,
      });
      _acChartData.push({
        id: PROVIDER_ID,
        // value: Math.ceil(total_price / products.length * 100) / 100,
        value: ac_total_price,
        label: PROVIDER_NAME,
      });
      if (isLplPage) {
        const second_plan = Number(
          _products[
            _products.findIndex((item: any) =>
              item.plan_name.includes("A/C Protect Plus")
            )
          ]["price1000"]
        );
        _chartData.push({
          id: PROVIDER_ID,
          // value: Math.ceil(total_price / products.length * 100) / 100,
          value: second_plan,
          label: PROVIDER_NAME,
        });
      }

      // Determine number of competitors to display and specific provider selection
      const isTwoProviderKh = promoCode && ["OFFERKH1", "OFFERKH3"].includes(promoCode);
      const numCompetitors = isTwoProviderKh ? 1 : 3;

      // Special provider selection for KH codes
      let selectedCompetitorData = [];
      
      if (promoCode === "OFFERKH1") {
        // OFFERKH1: Compare with Reliant (Secure Advantage 12 Plan) - provider_id "159"
        // First try to find Reliant's "Secure Advantage" plan specifically
        const reliantSecureAdvantage = plans && plans[159]?.find(
          (plan: PlanProps) => plan.plan_name.toLowerCase().includes("reliant secure advantage® 12 plan")
        );
        
        if (reliantSecureAdvantage) {
          // Use the specific "Secure Advantage" plan
          selectedCompetitorData = [{
            id: "159",
            value: Number(reliantSecureAdvantage[priceType as keyof PlanProps]),
            label: "Reliant",
            planName: reliantSecureAdvantage.plan_name
          }];
          
        } else {
          // Fallback to any Reliant plan
          const reliantData = data.filter((item: any) => item.id === "159");
          if (reliantData.length > 0) {
            selectedCompetitorData = reliantData;
          } else {
            // Fallback to lowest price if Reliant not found
            selectedCompetitorData = data.slice(-1);
          }
        }
        
      } else if (promoCode === "OFFERKH3") {
        const txuPlans = plans && plans[176] ? plans[176] : [];
      
        // Pick Saver's Choice 12 first
        const txuSaversChoice = txuPlans.find(
          (plan: PlanProps) => plan.plan_name.toLowerCase().includes("saver's choice 12")
        );      
        console.log("txuSaversChoice", txuSaversChoice);
      
        if (txuSaversChoice) {
          selectedCompetitorData = [{
            id: "176",
            value: Number(txuSaversChoice[priceType as keyof PlanProps]),
            label: "TXU Energy",
            planName: txuSaversChoice?.plan_name
          }];
        } else {
          // fallback (only if saver not found)
          const fallback = txuPlans.find((plan: PlanProps) => plan.plan_name.toLowerCase().includes("Saver's Choice 12")) || txuPlans[0];
          selectedCompetitorData = [{
            id: "176",
            value: Number(fallback[priceType as keyof PlanProps]),
            label: "TXU Energy",
            planName: fallback.plan_name
          }];
        }
      }else {
        // Default behavior for other codes
        if (data.length >= numCompetitors) {
          selectedCompetitorData = data.slice(-numCompetitors);
        } else {
          selectedCompetitorData = data.slice(-1 * data.length - 1);
        }
      }

      // Add selected competitors to chart data
      _chartData = _chartData.concat(selectedCompetitorData);
      _acChartData = _acChartData.concat(ac_data.slice(-3));

      // AC Protection Grid(If competitor drops more than 0.5 take of grid)
      const parsedData = _chartData.filter(
        (item: any) => item.value - _chartData[0].value > -0.5
      );
      // If all the three competior prices drop show most expensive 2
      if (parsedData.length === 1) {
        parsedData.push(
          ..._chartData
            .slice(1)
            .sort((a: any, b: any) => (a.val < b.val ? -1 : 1))
            .slice(1, 3)
        );
      }
      setChartData(parsedData);
      setChartLoading(false);
      setTimeout(() => {
        handleScroll();
      }, 200);
    }
  };

  useEffect(() => {
    if (isThreePlan) {
      getThreeHeightsRate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threeHeightPlans, products]);

  const getThreeHeightsRate = (flag?: boolean) => {
    if (products.length === 0 || !threeHeightPlans || chartData.length !== 0)
      return;
    let priceType = "price" + "1000";
    let total_price = 0;
    if (products[0][priceType as keyof PlanProps]) {
      total_price = Number(
        products.sort((a, b) => {
          return a.rate - b.rate;
        })[0][priceType as keyof PlanProps]
      );
    } else {
      total_price =
        (Number(
          products.sort((a, b) => {
            return a.rate - b.rate;
          })[0].month[1]
        ) /
          Number("1000")) *
        100;
    }
    let _allplans: any = threeHeightPlans;
    const data = [];
    for (let i in _allplans) {
      if (Tier.includes(Number(i)) || flag) {
        const _plans = _allplans[i];

        _plans.sort((a: any, b: any) => {
          if (a.total_rate < b.total_rate) return -1;
          if (a.value > b.value) return 1;
          return 0;
        });

        if (i !== PROVIDER_ID) {
          data.push({
            id: i,
            value: _plans[0].total_rate,
            label: _plans[0].provider_name,
          });
        }
      } else {
        continue;
      }
    }

    data.sort((a, b) => {
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
    let _chartData: any = [];
    _chartData = _chartData.concat(data.slice(3));
    _chartData.sort((a: any, b: any) => {
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
    _chartData.unshift({
      id: PROVIDER_ID,
      value: total_price,
      label: PROVIDER_NAME,
    });

    setChartData(
      _chartData.filter((item: any) => item.value >= _chartData[0].value)
    );
    setChartLoading(false);
    setTimeout(() => {
      handleScroll();
    }, 200);
  };

  // If user lands on the AC offer codes then fetch the ac plans
  useEffect(() => {
    const fetchACPlans = async () => {
      const data = await fetch("constants/AC_PLANS.json");
      const resp = await data.json();
      if (isLplPage) {
        setACPlans(resp["LPL_PLANS"]);
        setACRows(resp["LPL_ROWS"]);
      } else {
        setACPlans(resp["ONCOR_CNP_PLANS"]);
        setACRows(resp["ONCOR_CNP_ROWS"]);
      }
    };
    fetchACPlans();
  }, [isLplPage]);

  return (
    <SectionWrapper>
      <section className="cta" style={{ background: "#3286D3" }}>
        <div className="container"> 
          <div className="row  py-5" style={{marginBottom: 'inherit'}}>
            <div className="col-12 col-md-1"></div>
            <div className="col-12 col-md-8">
              <Grid
                container
                position="relative"
                alignItems="left"
                justifyContent={isComparePage ? "left" : 'space-between'}
                sx={{
                  pt: 3,
                  pb: 3,
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
                style={{ background: "#3286D3" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={8}
                  md={8}
                  position="relative"
                  zIndex="1"
                  textAlign={{ xs: "center", md: "left" }}
                  pr={{ md: 4 }}
                  pb={{ xs: 3, sm: 3 }}
                  pt={{ md: 2 }}
                >
                  <>
                    {/* <h2 style={{ marginTop: 0, fontWeight: 700, color: "#fff" }}>
                      Raise your expectations, <strong style={{ color: "#CADB2E" }}>lower</strong> your <strong style={{ color: "#CADB2E" }}>rate</strong>
                    </h2> */}
                    <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "25px", sm: "36px", md: "40px" },
                      margin: '40px 0',
                      fontWeight: 700,  
                      color: "#fff",
                    }}
                    >
                       It’s time to <strong style={{ color: "#CADB2E" }}>SWITCH </strong> your electricity provider. See if you can <strong style={{ color: "#CADB2E" }}>SAVE</strong> with Constellation.
                        {/* Raise your expectations, <strong style={{ color: "#CADB2E" }}>lower</strong> your <strong style={{ color: "#CADB2E" }}>rate</strong> */}
                    </Typography> 
                    
                  </>
                </Grid>
              </Grid>
            </div>
            <div className="col-12 col-md-4"></div>
          </div>
        </div>
        <div className="hero-image">
          <picture >
            <img
              src="/images/img-girl.png"
              alt="raise your expectations"
            />
          </picture>
        </div>
      </section>      
      <ChartSection  ref={mainRef}>
        {(loading || chartLoading) && (
          <CircularProgress style={{ margin: "100px 0" }} />
        )}
        <>
          {selectedUtility && selectedTerm && !chartLoading &&(
            <ACGridContainer >
              <h2 style={{ marginBottom: "15px" }}>
                Estimated Total Savings ={" "}
                <RollingNumber
                  data={energySavings}
                  styles={{ color: "#2372B9", fontWeight: 700 }}
                />
              </h2>
              <p
                style={{
                  color: "#333",
                  fontSize: "14px",
                  fontWeight: 400,
                  marginBottom: "15px",
                }}
              >
                Savings based on highest rate shown in the comparison below.
              </p>
              <CompareGridContext.Provider
                value={{
                    products: products,
                    acPlans: acPlans,
                    acRows: acRow,
                    gridData: chartData,
                    setOneRepPlanList: setOneRepPlanList,
                    setShowModal: setShowModal,
                    isLplPage: isLplPage,
                    isDmPage: isDmPage,
                    showModal,
                    promoCode: promoCode,
                    isKhPage: isKhPage,
                    zipcode: zipcode,
                    utilityCode: findUtilityCode(),
                    state: (() => {
                      try {
                        const utility = JSON.parse(localStorage.getItem("utility") || "{}");
                        return utility?.state_id || "TX";
                      } catch {
                        return "TX";
                      }
                    })()
                  }}
                >
                 
                <CompareGrid/>
              </CompareGridContext.Provider>
              
            </ACGridContainer>
          )}
        </>
      </ChartSection>
      <HomeIntroSection>
        <Container>
          <img src="images/best_texas_2024_badge.png" alt="" />
          <HomeIntroContentSection>
            <p>Did you know?</p>
            <p>
              Constellation was selected as the{" "}
              <strong>Best Texas Provider</strong> by ElectricityRates.com in
              2023 and 2024.
            </p>
          </HomeIntroContentSection>
        </Container>
      </HomeIntroSection>
      <IntroSection color="#fff">
        <Container sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
          <Grid
            container
            position="relative"
            spacing={{ xs: 2, sm: 3 }}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid
              item
              xs={12}
              sm={6}
              position="relative"
              zIndex="1"
              textAlign="center"
              order={0}
            >
              <IntroContentSection>
                <h2>Why Switch to Constellation?</h2>
                <p>
                  Constellation offers a variety of home energy options to fit
                  your budget, values and needs. Compare plan benefits and see
                  why over 2 million customers choose Constellation as their
                  trusted energy supplier.
                </p>
              </IntroContentSection>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              position="relative"
              zIndex="1"
              textAlign="center"
              alignSelf={"flex-start"}
              order={1}
            >
              <TickGrid>
                <TickSection style={{ backgroundColor: "#12385D" }}>
                  <img src="/images/icon-tick.png" alt="" />
                  <h3>Fixed Rates</h3>
                  <p>
                    Enjoy price stability for the duration of your plan term
                  </p>
                </TickSection>
                <TickSection style={{ backgroundColor: "#6AA443" }}>
                  <img src="/images/icon-tick.png" alt="" />
                  <h3>Bill Credits</h3>
                  <p>Earn up to $50 back on your monthly bill</p>
                </TickSection>
              </TickGrid>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              position="relative"
              zIndex="1"
              textAlign="center"
              alignSelf={"flex-end"}
              order={{ xs: 4, sm: 3 }}
            >
              <TickGrid>
                <TickSection style={{ backgroundColor: "#2073B7" }}>
                  <img src="/images/icon-tick.png" alt="" />
                  <h3>Easy Setup</h3>
                  <p>Enroll online or over the phone in 5 minutes</p>
                </TickSection>
                <TickSection style={{ backgroundColor: "#F37C27" }}>
                  <img src="/images/icon-tick.png" alt="" />
                   <h3>ETF Coverage</h3>
                  <p>We will cover your early termination fee up to $150</p>
                </TickSection>
              </TickGrid>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              position="relative"
              zIndex="1"
              textAlign="center"
              alignSelf={"flex-end"}
              order={{ xs: 3, sm: 4 }}
            >
              <IntroContentSection marginTop={"-80px"}>
                <img src={"images/best_texas_2024_badge.png"} height={160} />
              </IntroContentSection>
            </Grid>
          </Grid>
        </Container>
      </IntroSection>
      <ChoiceSection>
        <Container>
          <h2>The Power of Choice</h2>
          <p>
            At Constellation, we take pride in offering a wide selection of
            energy plans to meet the diverse needs of our customers. However, it
            is important to note that the plans you see on this landing page do
            not represent all plans available in your market. The comparisons
            you see on here are against companies that we believe meet our
            standard of quality, but we encourage you to continue your research
            and due diligence to find the plan that best fits your needs.
          </p>
          <Button
            onClick={() => {
              handleScroll();
            }}
            //style={{background:"none"}}
            //variant="contained"
            //className="default-button"
          >
            Back to Plans
          </Button>
        </Container>
      </ChoiceSection>
      <EvaluateSection>
        <Container>
          <h3 style={{ fontWeight: "600" }}>
            See what our customers are saying
          </h3>
          <GoogleSwiper />
          <img src="/images/google_review.png" alt="" height={150} />
        </Container>
      </EvaluateSection>
      <PlanModal
        show={showModal}
        data={oneRepPlanList}
        handleClose={() => {
          setShowModal(false);
        }}
        selectProduct={() => {}}
        promoCode={promoCode}
        avgMonthlyUse={"1000"}
      />
      <ErrorModal
        content={errorModalContent}
        handleClose={() => setErrorModalContent(undefined)}
      />
    </SectionWrapper>
  );
};

export default withSnackbar(AcPage);
